import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { StorageManager } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

import {
  CXFROM_STORAGE_KEY,
  OAUTH_FLOW_TYPE_STORAGE_KEY,
  OAUTH_FLOW_TYPES,
} from 'common/constants';
import { LocalConfig } from 'common/utils/utils';

const SOCIAL_LINKS = {
  GOOGLE: ({ projectId }) => `/api/auth/oauth2/authorization/google-${projectId}`,
};

const SocialProviders = ({ flowType, items = [], redirectPath }) => {
  const providers = useMemo(
    () =>
      items.map((provider, i) => ({
        id: i,
        link: SOCIAL_LINKS[provider]({ projectId: LocalConfig.get('projectId') }),
        name: provider,
      })),
    [items],
  );

  if (!providers.length) return null;

  const handleClick = () => {
    if (redirectPath) {
      StorageManager.setItem(CXFROM_STORAGE_KEY, redirectPath);
    }
    if (flowType) {
      StorageManager.setItem(OAUTH_FLOW_TYPE_STORAGE_KEY, flowType);
    }
  };

  return (
    <div className="social-signup">
      <div className="social-signup-title">
        <hr />
        <Label message="social_login_with" />
        <hr />
      </div>

      {providers.map(({ id, link, name }) => (
        <a className="social-signup-item" href={link} key={id} onClick={handleClick}>
          <Icon height={26} name="google" width={26} />
          <Label message={`social_login_${name.toLowerCase()}`} />
        </a>
      ))}
    </div>
  );
};

SocialProviders.propTypes = {
  flowType: PropTypes.oneOf(Object.values(OAUTH_FLOW_TYPES)),
  items: PropTypes.arrayOf(PropTypes.string),
  redirectPath: PropTypes.string,
};

export default SocialProviders;
